export const ROUTES = {
  ANALYTICS_PAGE: '/analytics',
  HOME_PAGE: '/',
  FORGOT_PASSWORD_PAGE: '/forgot-password',
  DASHBOARD_PAGE: '/dashboard',
  PROFILE_PAGE: '/profile',
  SCHOOL_PROFILE_PAGE: '/school-profile',
  COURSES_PAGE: '/courses',
  COURSES_LESSONS_PAGE: '/courses-lessons',
  COURSE_PAGE: '/courses/:id',
  COURSE_PREVIEW_PAGE: 'courses/:id/preview',
  STUDENTS_PAGE: '/students',
  STUDENT_PAGE: '/students/:id',
  ADMINS_PAGE: '/admins',
  ADMIN_PAGE: '/admins/:id',
  SCHOOLS_PAGE: '/schools',
  SCHOOL_PAGE: '/schools/:id',
  SCHOOL_CURATOR_REPORT_PAGE: '/school-report/:token',
  SCHOOL_CURATOR_STUDENT_PAGE: '/school-report/:token/students/:studentId',
  SCHOOL_CURATOR_DASHBOARD_PAGE: '/schools/:id/curator-dashboard',
  SCHOOL_CURATOR_DASHBOARD_STUDENT_PAGE:
    '/schools/:id/curator-dashboard/students/:studentId',
  INBOX_PAGE: '/inbox',
  COURSE_LESSON_PAGE: '/courses/:courseId/lessons/:lessonId',
  COURSE_LESSON_PREVIEW_PAGE: '/courses/:courseId/lessons/:lessonId/preview',
  FIGMA_LESSON_AUTH_PAGE: '/auth/figma',
  ARCADES_PAGE: '/arcades',
  ARCADE_PAGE: '/arcades/:id',
  ARCADE_PREVIEW_PAGE: 'arcades/:id/preview',
  ARCADE_LESSON_PAGE: '/arcades/:courseId/lessons/:lessonId',
  ARCADE_LESSON_PREVIEW_PAGE: '/arcades/:courseId/lessons/:lessonId/preview',
  TRAININGS_PAGE: '/trainings',
  TRAINING_PAGE: '/trainings/:id',
  TRAINING_PREVIEW_PAGE: 'trainings/:id/preview',
  TRAINING_LESSON_PAGE: '/trainings/:courseId/lessons/:lessonId',
  TRAINING_LESSON_PREVIEW_PAGE:
    '/trainings/:courseId/lessons/:lessonId/preview',
  DAILY_CHALLENGES_PAGE: '/daily-challenges',
  DAILY_CHALLENGE_PAGE: '/daily-challenges/:id',
  DAILY_CHALLENGE_PREVIEW_PAGE: 'daily-challenges/:id/preview',
  DAILY_CHALLENGE_LESSON_PAGE:
    '/daily-challenges/:courseId/lessons/:lessonId',
  DAILY_CHALLENGE_LESSON_PREVIEW_PAGE:
    '/daily-challenges/:courseId/lessons/:lessonId/preview',
  LEARNING_PATH_PAGE: '/learning-path',
  LEARNING_PATH_MODULE_PAGE: '/learning-path/courses/:id',
  LEARNING_PATH_LESSON_PAGE:
    '/learning-path/courses/:courseId/lessons/:lessonId',
  LESSON_CATEGORIES_PAGE: '/lesson-categories',
  LESSON_CATEGORY_PAGE: '/lesson-categories/:id',
  LESSONS_PAGE: '/lessons',
  LESSON_PAGE: '/lessons/:lessonId',
};
